import { useState } from 'react'
import { publicCacheService } from '../utils/publicCacheService'

function AdminCacheManager() {
  const [isRefreshing, setIsRefreshing] = useState(false)
  
  const lastUpdate = publicCacheService.getLastUpdateTime()
  const isEmpty = publicCacheService.isCacheEmpty()
  
  const handleRefreshCache = async () => {
    setIsRefreshing(true)
    try {
      // Trigger cache updates from all admin panels
      window.dispatchEvent(new CustomEvent('adminCacheRefresh'))
      
      // Show completion after a brief delay
      setTimeout(() => {
        setIsRefreshing(false)
        alert('Public cache refreshed successfully!')
      }, 2000)
      
    } catch (error) {
      console.error('Cache refresh error:', error)
      setIsRefreshing(false)
      alert('Error refreshing cache. Please try again.')
    }
  }

  const handleClearCache = () => {
    if (confirm('Are you sure you want to clear all public cache? This will make the website empty for visitors until you refresh the cache.')) {
      publicCacheService.clearCache()
      alert('Public cache cleared successfully!')
    }
  }

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="mb-0">🗄️ Public Cache Management</h5>
        <div className="d-flex gap-2">
          <button 
            className="btn btn-primary btn-sm"
            onClick={handleRefreshCache}
            disabled={isRefreshing}
          >
            {isRefreshing ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Refreshing...
              </>
            ) : (
              '🔄 Refresh Cache'
            )}
          </button>
          <button 
            className="btn btn-outline-danger btn-sm"
            onClick={handleClearCache}
          >
            🗑️ Clear Cache
          </button>
        </div>
      </div>
      <div className="card-body">
        <div className="row g-3">
          <div className="col-md-6">
            <div className="d-flex justify-content-between">
              <span className="text-muted">Cache Status:</span>
              <span className={isEmpty ? 'text-danger fw-bold' : 'text-success fw-bold'}>
                {isEmpty ? 'Empty' : 'Active'}
              </span>
            </div>
            <div className="d-flex justify-content-between">
              <span className="text-muted">Last Updated:</span>
              <span className="fw-bold">
                {lastUpdate ? lastUpdate.toLocaleString() : 'Never'}
              </span>
            </div>
          </div>
          <div className="col-md-6">
            <div className="d-flex justify-content-between">
              <span className="text-muted">Classes Cached:</span>
              <span className="fw-bold">{publicCacheService.getClasses().length}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span className="text-muted">Images Cached:</span>
              <span className="fw-bold">{publicCacheService.getImages().length}</span>
            </div>
          </div>
        </div>
        
        {isEmpty && (
          <div className="alert alert-warning mt-3 mb-0">
            <small>
              ⚠️ <strong>Warning:</strong> The public cache is empty. Visitors won't see any classes, kits, or gallery items. 
              Click "Refresh Cache" to populate it with current SharePoint data.
            </small>
          </div>
        )}
      </div>
    </div>
  )
}

export default AdminCacheManager